module.exports = __webpack_public_path__ + "static/media/Sidonian_canaanite-phoenician_icon_200px.155e06d5.png";